var _mask, _rect, _mask2, _rect2, _mask3, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectedNurtureTabIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3798_4574",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 18,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 18,
    rx: 1,
    stroke: "#11C89B",
    strokeWidth: 3,
    mask: "url(#path-1-inside-1_3798_4574)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3798_4574",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 6,
    height: 12.375,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 6,
    height: 12.375,
    rx: 1,
    stroke: "#11C89B",
    strokeWidth: 3,
    mask: "url(#path-2-inside-2_3798_4574)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_3798_4574",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 6,
    height: 9,
    rx: 1
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 6,
    height: 9,
    rx: 1,
    stroke: "#11C89B",
    strokeWidth: 3,
    mask: "url(#path-3-inside-3_3798_4574)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2.28125,
    y: 0.28125,
    width: 13.4375,
    height: 0.5625,
    fill: "#8A94A6",
    stroke: "#11C89B",
    strokeWidth: 0.5625
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 7,
    width: 0.5,
    height: 4,
    fill: "#8A94A6",
    stroke: "#11C89B",
    strokeWidth: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedNurtureTabIcon);
export default __webpack_public_path__ + "static/media/SelectedNurtureTabIcon.5f4bdc263b432000a46f36c950ababa2.svg";
export { ForwardRef as ReactComponent };